import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { TechnicalTrainingService } from "src/app/core/services/technicalTrainins.service";
import { CloseNotifComponent } from "../close-notif/close-notif.component";

@Component({
  selector: "app-edit-technical-training",
  templateUrl: "./edit-technical-training.component.html",
  styleUrls: ["./edit-technical-training.component.scss"],
})
export class EditTechnicalTrainingComponent implements OnInit {

  showTagalog: boolean = false;
  buttonColor: string = "accent";
  language: string = "Translate to Tagalog";
  textClass: string = "text-black"

  editTrainingsFormGroup: FormGroup;

  successMessage: boolean = false
  errorMessage: boolean = false

  othersCertificate: any;
  isItemBeingUpdated: boolean = false;
  isButtonDisabled: boolean = false;

  certifateTypes: any = [
    { id: 1, name: "NC I" },
    { id: 2, name: "NC II" },
    { id: 3, name: "NC III" },
    { id: 4, name: "NC IV" },
    { id: 5, name: "Others" },
  ];

  constructor(
    private fb: FormBuilder,
    private technicalTrainingService: TechnicalTrainingService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.editTrainingsFormGroup = this.fb.group({
      applicantId: this.data.selectedItem.applicantId,
      trainingCourse: ["", [Validators.required, this.notEmptyString]],
      hoursOfTraining: ["", Validators.required],
      trainingInstitution: ["", Validators.required],
      certificates: ["", Validators.required],
      certificatesOthers: ["", this.notEmptyString],
      skillsAcquired: ["", [Validators.required, this.notEmptyString]],
    });

    const selectedCertificates = this.data.selectedItem.certificates;

    if (
      selectedCertificates !== "NC I" &&
      selectedCertificates !== "NC II" &&
      selectedCertificates !== "NC III" &&
      selectedCertificates !== "NC IV"
    ) {
      this.othersCertificate =
        this.certifateTypes[this.certifateTypes.length - 1].name;

      this.editTrainingsFormGroup.patchValue({
        trainingCourse: this.data.selectedItem.trainingCourse,
        hoursOfTraining: this.data.selectedItem.hoursOfTraining,
        trainingInstitution: this.data.selectedItem.trainingInstitution,
        skillsAcquired: this.data.selectedItem.skillsAcquired,
        certificatesOthers: this.data.selectedItem.certificates,
      });

      this.editTrainingsFormGroup
        .get("certificatesOthers")
        .setValidators([Validators.required, this.notEmptyString]);
    } else {
      this.othersCertificate = selectedCertificates;

      this.editTrainingsFormGroup.patchValue({
        trainingCourse: this.data.selectedItem.trainingCourse,
        hoursOfTraining: this.data.selectedItem.hoursOfTraining,
        trainingInstitution: this.data.selectedItem.trainingInstitution,
        skillsAcquired: this.data.selectedItem.skillsAcquired,
        certificatesOthers: this.data.selectedItem.certificatesOthers,
      });

      this.editTrainingsFormGroup.get("certificatesOthers").clearValidators();
    }

    this.editTrainingsFormGroup
      .get("certificatesOthers")
      .updateValueAndValidity();
  }

  updateTechnicalTraining() {
    if (this.editTrainingsFormGroup.invalid) {
      this.errorMessage = true

      setTimeout(() => {
        this.errorMessage = false;
      }, 3000);
    } else {
      this.isItemBeingUpdated = true;
      this.isButtonDisabled = true;

      const technicalTrainingData = {
        applicantId: this.data.selectedItem?.applicantId,
        id: this.data.selectedItem.id,
        trainingCourse:
          this.editTrainingsFormGroup?.controls.trainingCourse.value || "",
        hoursOfTraining:
          this.editTrainingsFormGroup.controls?.hoursOfTraining.value || "",
        trainingInstitution:
          this.editTrainingsFormGroup.controls?.trainingInstitution.value || "",
        skillsAcquired:
          this.editTrainingsFormGroup.controls?.skillsAcquired.value || "",
        certificates:
          this.editTrainingsFormGroup.controls?.certificates.value || "",
      };

      const certificateType =
        this.editTrainingsFormGroup.controls.certificates.value;

      if (certificateType == "Others") {
        (technicalTrainingData.certificates =
          this.editTrainingsFormGroup.controls?.certificatesOthers.value || ""),
          this.technicalTrainingService
            .updateTechnicalTraining(technicalTrainingData)
            .subscribe(() => {
              this.isItemBeingUpdated = false;
              this.isButtonDisabled = false;

              this.successMessage = true

              setTimeout(() => {
                this.dialog.closeAll();
              }, 3000);
            });
      } else {

        this.technicalTrainingService
          .updateTechnicalTraining(technicalTrainingData)
          .subscribe(() => {
            this.isItemBeingUpdated = false;
            this.isButtonDisabled = false;

            this.successMessage = true

            setTimeout(() => {
              this.dialog.closeAll();
            }, 3000);
          });
      }
    }
  }

  hideSuccessMessage() {
    this.successMessage = false;
  }

  closeNotif() {
    this.dialog.open(CloseNotifComponent);
  }

  notEmptyString(control) {
    const value = control.value;

    if (value === null || value.trim() === "") {
      return { notEmptyString: true };
    }

    return null;
  }

  toggleTagalogTranslation(){

    this.showTagalog = !this.showTagalog;
    this.language =
      this.language === "Translate to Tagalog"
        ? "Translate to English"
        : "Translate to Tagalog";

    this.buttonColor =
      this.language === "Translate to Tagalog" ? "accent" : "primary";
    this.textClass = this.language == "Translate to Tagalog" ? "text-black" : "text-white";

  }
}
